<div class="nhsuk-grid-row app-width">
  <!--  <app-back-button fallbackRoute="/admin" backLabel="Back to admin" />-->
  <br />
  <h1>Admin</h1>
</div>

<section class="nhsuk-grid-row app-width grid-4-columns gap-32">
  <app-admin-navigation />
  <div class="grid-item-span-3">
    @if (true) {
      <router-outlet />
    } @else {
      <app-error-summary error="No patient found!" />
    }
  </div>
</section>
